module.exports = "/img/echarts.67900a4f.png";